import {getChampionships} from '@monpetitgazon/mpg-team-data';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import {getMPMUsersByMatches} from '../../../../../../actions/entities/statistics/mpmUsers';
import {championshipsRefs} from '../../../../../../components/ChampionshipSelector';
import FilterLocation from '../../../../../../components/Filters/Location';
import Loader from '../../../../../../components/Loader';
import map from 'lodash/map';
import {champIds} from '../../../../../../helpers/championship';
import {AVAILABLE_SEASONS} from '../../../../../../types/common';

class MPMUsersByMatchesWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      championship: 'FR',
      season: AVAILABLE_SEASONS[0],
      data: null,
      loading: false,
    };
  }

  toggleChamp(value) {
    this.fetchStats(value);
    this.setState({championship: value});
  }

  getValues(value) {
    const data = Object.values(value.competitionMatches);
    var total = 0;
    var activeUsers = 0;

    for (var i = 0; i < data.length; i++) {
      total += data[i].total;
      activeUsers += data[i].activeUsers;
    }
    return {total, activeUsers};
  }

  renderTable() {
    const {data} = this.state;

    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <td className="text-center">
                <b>Journée</b>
              </td>
              <td className="text-center">
                <b>Users (live)</b>
              </td>
              <td className="text-center">
                <b>Users actifs les 7 derniers jours</b>
              </td>
              <td className="text-center">
                <b>Date de calcul</b>
              </td>
            </tr>
          </thead>
          <tbody>
            {map(data, (item, name) => {
              const headerValues = this.getValues(item);
              return (
                <tr key={name} data-toggle="collapse" data-target={`.${name}`}>
                  <td style={{width: '150px '}}>
                    {name}
                    <div className={`${name} collapse`}>
                      {map(item.competitionMatches, (value, index) => (
                        <div key={index} className="text-center">
                          <b>{value.matchTitle}</b>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td style={{width: '150px '}}>
                    {headerValues.total}
                    <div className={`${name} collapse`}>
                      {map(item.competitionMatches, (value, index) => (
                        <div key={index} className="text-center">
                          <b>{value.total}</b>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td style={{width: '150px '}}>
                    {headerValues.activeUsers}
                    {map(item.competitionMatches, (value, index) => (
                      <div className={`${name} collapse`}>
                        <div key={index} className="text-center">
                          <b>{value.activeUsers}</b>
                        </div>
                      </div>
                    ))}
                  </td>
                  <td style={{width: '150px '}}>
                    <div style={{height: '20px'}} />
                    <div className={`${name} collapse`}>
                      {map(item.competitionMatches, (value, index) => (
                        <div key={index} className="text-center">
                          <b>
                            {moment(value.calculationDate).format('DD/MM/YYYY')}
                          </b>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  fetchStats(championship) {
    const {dispatch} = this.props;
    const {season} = this.state;
    const onSuccess = response =>
      this.setState({data: response.rounds, loading: false});
    dispatch(
      getMPMUsersByMatches(
        {
          competitionId: champIds[championship || this.state.championship],
          competitionYear: season,
        },
        onSuccess,
        null,
        () => this.setState({loading: true}),
      ),
    );
  }

  render() {
    const {championship, season, data, loading} = this.state;
    const availableButtons = [
      ...getChampionships().map(value =>
        championshipsRefs[value.ref].toUpperCase(),
      ),
    ];

    return (
      <div id="season-active-users-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-user-circle-o" /> Users by matches
            </h3>
          </div>
          <div className="box-body text-center">
            <div className="margin-bottom text-center inline">
              <FilterLocation
                label="Championship:"
                availableButtons={availableButtons}
                onChange={championship => this.toggleChamp(championship)}
                initialValue={championship}
              />
              <select
                style={{width: '200px'}}
                className="inline form-control"
                value={season}
                onChange={e => this.setState({season: e.target.value})}>
                {AVAILABLE_SEASONS.map(season => (
                  <option value={season}>{season}</option>
                ))}
              </select>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
            {data && this.renderTable()}
          </div>
          {loading && <Loader />}
        </div>
      </div>
    );
  }
}

export default connect(dispatch => ({dispatch}))(MPMUsersByMatchesWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPM/Stats/Widgets/UsersByMatches/index.js